import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../product/product-detail.schema'

/** Icons the trust cards draw (the theme's line icons). */
const TRUST_ICONS = [
  { label: 'Shield', value: 'shield' },
  { label: 'Exchange arrows', value: 'refresh' },
  { label: 'Lock', value: 'lock' },
  { label: 'Delivery truck', value: 'truck' },
  { label: 'Cash', value: 'cash' },
  { label: 'Parcel', value: 'package' },
  { label: 'Star', value: 'star' },
  { label: 'Tick', value: 'check' },
]

/**
 * Mohalla product page: the base fields plus the size chart (merchant rich text, opened from a "Size chart" link
 * beside the sizes), the "Suggested picks" rows in the summary column, the "Additional information" tab with the
 * delivery areas table, the delivery lines with green dots and the three trust cards under the buttons. All
 * optional; empty values hide their piece.
 */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    ...base.commonFields,
    { key: 'sizeGuideTitle', label: 'Size chart title and link', type: 'string', default: 'Size chart' },
    { key: 'sizeGuide', label: 'Size guide', type: 'rich-text', help: 'Measurements table or fit notes, opened from the "Size chart" link beside the sizes. Two tables, inches then centimetres, get Inch / CM tabs. Hidden while empty.' },
    { key: 'completeTheLookTitle', label: '"Suggested picks" title', type: 'string', default: 'Suggested picks', help: 'Up to five other products from the same category, shown as compact rows beside the photos (under them on phones).' },
    { key: 'additionalInfoTitle', label: '"Additional information" tab title', type: 'string', default: 'Additional information', help: 'The product\'s options (sizes, colours…), the delivery and returns policy and the delivery areas.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
    {
      key: 'deliveryPoints',
      label: 'Delivery lines',
      type: 'array',
      help: 'Short lines with a green dot under the buttons.',
      itemSchema: [{ key: 'text', label: 'Line', type: 'string' }],
      default: [
        { text: 'Delivery all over Bangladesh' },
        { text: 'Cash on delivery available' },
        { text: 'Check the parcel before you pay' },
      ],
    },
    {
      key: 'trustCards',
      label: 'Trust cards',
      type: 'array',
      help: 'Up to three small cards under the delivery lines.',
      itemSchema: [
        { key: 'icon', label: 'Icon', type: 'select', options: TRUST_ICONS, default: 'shield' },
        { key: 'title', label: 'Title', type: 'string' },
        { key: 'text', label: 'Line', type: 'string' },
      ],
      default: [
        { icon: 'shield', title: 'Quality checked', text: 'Every piece checked before it ships' },
        { icon: 'refresh', title: 'Easy exchange', text: 'Wrong size? Swap it within 7 days' },
        { icon: 'lock', title: 'Safe payment', text: 'Pay on delivery or online' },
      ],
    },
  ],
}
